import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import type { AlertType } from '../alerts/types';

const textBaseStyle = css`
  display: flex;
  align-items: center;
  margin: 0;
  padding: ${theme.spacing(2, 2, 2, 1.5)};

  &::before {
    content: '';
    width: 4px;
    height: 100%;
    border-top-left-radius: ${theme.borderRadius.medium};
    border-bottom-left-radius: ${theme.borderRadius.medium};
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }

  svg {
    min-width: 24px;
    margin-right: ${theme.spacing(1)};
  }
`;

const textTypeStyles = {
  error: css`
    &::before {
      background: ${theme.colors.status.critical};
    }
  `,
  info: css`
    &::before {
      background: ${theme.colors.primary50};
    }
  `,
  success: css`
    &::before {
      background: ${theme.colors.status.success};
    }
  `,
  warning: css`
    &::before {
      background: ${theme.colors.status.warning};
    }
  `,
};

export const alertContainerStyle = css`
  width: 100%;
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.small};
  box-shadow: ${theme.shadows.heavy};
  cursor: pointer;
  overflow: hidden;
  position: relative;
  pointer-events: all;
  z-index: ${theme.zIndex.low};
`;

export const getAlertTextClassName = (type: AlertType) => cx(textBaseStyle, textTypeStyles[type]);
